module.exports = __webpack_public_path__ + "static/download/우아한형제들_가치경영보고서_배민스토리2025.pdf";